<div :class="['client-sidebar', { close: isClosed }]" class="d-flex flex-column justify-content-between">
  <div>
    <div class="logo-details">
      <img :src="$sideLogo" class="img-fluid mx-auto d-block mt-3 w-70px" alt="">
    </div>
    <div class="border-top border-primary border-3 mt-2 mb-2"></div>

    <ul class="nav flex-column mt-2 h-100">
      <!-- Dashboard -->
      <li>
        <router-link to="/dashboard" class="nav-item nav-link  text-decoration-none">
          <i class='bi bi-grid-fill fs-6'></i>Dashboard
        </router-link>
      </li>
      <li class="">
        <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#trust_view" role="button" aria-expanded="false" aria-controls="trust_view">
          <span v-if="cbo_domain" class="">Manage Membership</span>
          <span v-else class=" "><i class='bx bx-command fs-6'></i> <span class="ms-2">Manage Portals</span></span>
          <i class="bi bi-chevron-down rotate-icon fs-6 "></i>
        </a>
        <ul class="collapse list-unstyled ps-3" id="trust_view">
          <li>
            <router-link to="/create_portal" class="nav-item nav-link text-decoration-none">
              <i class='bx bxs-chevrons-right fs-6 text-primary'></i> 
              <span v-if="cbo_domain"class="link-name">Memberships</span>
            <span v-else class="link-name">Portals</span>
            </router-link>
          </li>
          <li v-if="workbook_domain || stagging_domain">
            <router-link to="/manage_roles" class="nav-item nav-link text-decoration-none">
              <i class='bx bxs-chevrons-right fs-6 text-primary'></i> Roles
            </router-link>
          </li>
        </ul>
      </li>
      <li class="d-none">
        <a class="nav-item nav-link text-decoration-none d-flex justify-content-between" data-bs-toggle="collapse" href="#trustSetupMenu" role="button" aria-expanded="false" aria-controls="trustSetupMenu">
          <span><i class='bx bx-dollar fs-6'></i><span class="ms-2">Manage Profile</span> </span>
          <i class="bi bi-chevron-down rotate-icon fs-6"></i>
        </a>
        <ul class="collapse list-unstyled ps-3" id="trustSetupMenu">
          <li>
            <a href="/profile" class="nav-item nav-link text-decoration-none">
              <i class='bx bxs-chevrons-right fs-6 text-primary'></i> Profile
            </a>
          </li>
        </ul>
      </li>
     
    <!-- Task Management -->
      <li class="">
        <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#tasks" role="button" aria-expanded="false" aria-controls="tasks">
         <span><i class='bi bi-clock-fill fs-6'></i><span class="ms-2">Manage Events</span></span> 
          <i class="bi bi-chevron-down rotate-icon fs-6"></i>
        </a>
        <ul class="collapse list-unstyled ps-3" id="tasks">
          <li>
            <router-link to="/events" class="nav-item nav-link text-decoration-none">
              <i class='bx bxs-chevrons-right fs-6 text-primary'></i>Events
            </router-link>
          </li>
          <li>
            <router-link to="/get_rsvps" class="nav-item nav-link text-decoration-none">
              <i class='bx bxs-chevrons-right fs-6 text-primary'></i>RSVP
            </router-link>
          </li>
        </ul>
      </li>

       <!-- Client Management -->
       <li class="" v-if="!cbo_domain">
        <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#clients" role="button" aria-expanded="false" aria-controls="clients">
          <span><i class='bi bi-people-fill fs-6'></i> <span class="ms-2">Group Management</span></span>
          <i class="bi bi-chevron-down rotate-icon fs-6"></i>
        </a>
        <ul class="collapse list-unstyled ps-3" id="clients">
          <li v-if="!cbo_domain">
            <router-link to="/create_group" class="nav-item nav-link text-decoration-none">
              <i class='bx bxs-chevrons-right fs-6 text-primary'></i>Groups
            </router-link>
          </li>
        </ul>
      </li>

      <li class="">
        <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#users" role="button" aria-expanded="false" aria-controls="clients">
          <span><i class='bi bi-person-lines-fill  fs-6'></i><span class="ms-2">Manage Users</span></span>
          <i class="bi bi-chevron-down rotate-icon fs-6"></i>
        </a>
        <ul class="collapse list-unstyled ps-3" id="users">
          <li>
            <router-link to="/create_user" class="nav-item nav-link text-decoration-none">
              <i class='bx bxs-chevrons-right fs-6 text-primary'></i>Users
            </router-link>
          </li>
        </ul>
      </li>
    
      <!-- System Configuration -->
      <li v-if="!workbook_domain && !dwypd_domain" class="">
        <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#systemConfigMenu" role="button" aria-expanded="false" aria-controls="systemConfigMenu">
          <span><i class='bi bi-stickies-fill fs-6'></i> <span class="ms-2">Manage Membership</span></span>
          <i class="bi bi-chevron-down rotate-icon fs-6"></i>
        </a>
        <ul class="collapse list-unstyled ps-3" id="systemConfigMenu">
          <li>
            <router-link to="/create_membership" class="nav-item nav-link text-decoration-none  text-xxs">
              <i class='bx bxs-chevrons-right fs-6 text-primary'></i> Memberships
            </router-link>
          </li>
        </ul>
      </li>
      <li class="">
        <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#forms" role="button" aria-expanded="false" aria-controls="forms">
          <span><i class='bi bi-file-earmark-check-fill fs-6'></i> <span class="ms-2">Manage Forms</span></span>
          <i class="bi bi-chevron-down rotate-icon fs-6"></i>
        </a>
        <ul class="collapse list-unstyled ps-3" id="forms">
          <li>
            <router-link to="/create_form" class="nav-item nav-link text-decoration-none  text-xxs">
              <i class='bx bxs-chevrons-right fs-6 text-primary'></i> Forms
            </router-link>
          </li>
          <li>
            <router-link to="/manage_sections" class="nav-item nav-link text-decoration-none  text-xxs">
              <i class='bx bxs-chevrons-right fs-6 text-primary'></i> Sections
            </router-link>
          </li>
        </ul>
      </li>
      <li class="">
        <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#questions" role="button" aria-expanded="false" aria-controls="systemConfigMenu">
          <span><i class='bi bi-question-square-fill fs-6'></i> <span class="ms-2">Manage Questions</span></span>
          <i class="bi bi-chevron-down rotate-icon fs-6"></i>
        </a>
        <ul class="collapse list-unstyled ps-3" id="questions">
  
          <li>
            <router-link to="/manage_questions" class="nav-item nav-link text-decoration-none  text-xxs">
              <i class='bx bxs-chevrons-right fs-6 text-primary'></i> Question Bank
            </router-link>
          </li>
        </ul>
      </li>

      <li class="">
        <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#business_profile" role="button" aria-expanded="false" aria-controls="systemConfigMenu">
          <span><i class='bi bi-briefcase-fill fs-6'></i> <span class="ms-2">Manage Business</span></span>
          <i class="bi bi-chevron-down rotate-icon fs-6"></i>
        </a>
        <ul class="collapse list-unstyled ps-3" id="business_profile">
  
          <li>
            <router-link to="/view_business_dashboard" class="nav-item nav-link text-decoration-none  text-xxs">
              <i class='bx bxs-chevrons-right fs-6 text-primary'></i> Business Profiles
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
  <div class="d-flex justify-content-center mb-3">
   
  </div>
</div>

